import { toast } from '@qodo/design-system';
import { useMutation } from '@tanstack/react-query';
import { spawn } from 'utils/translations';
import { GitlabClient } from '../httpClients/GitlabClient';
import { GitlabProvisionGroupTokenRequest } from '../httpClients/GitlabClient/api.schema';
import { MUTATION_KEYS } from './consts';
import { getErrorToastContent } from './utils';

/**
 * Provisions a single GitLab group from a pasted Group Access Token; the backend
 * creates the group-level webhook. Distinct 400 codes surface via `getErrorToastContent`.
 * @returns The React Query mutation for the provision-group-token call.
 */
export const useProvisionGroupTokenMutation = () => {
  const spawnToasts = spawn('toasts.gitlab.provision-group-token');

  return useMutation({
    mutationKey: [MUTATION_KEYS.PROVISION_GITLAB_GROUP_TOKEN],
    mutationFn: (request: GitlabProvisionGroupTokenRequest) =>
      GitlabClient.provisionGroupToken(request),
    onError: (err: unknown) => {
      toast.error(getErrorToastContent(err, spawnToasts('error')));
    },
  });
};
